import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/database';

var firebaseConfig = {
  apiKey: "AIzaSyDACUbvPuPBtwxVkcMZEccUyQvRoWF5SYk",
  authDomain: "lmsv3-5ab3c.firebaseapp.com",
  databaseURL: "https://lmsv3-5ab3c.firebaseio.com",
  projectId: "lmsv3-5ab3c",
  storageBucket: "lmsv3-5ab3c.appspot.com",
  messagingSenderId: "628421430552",
  appId: "1:628421430552:web:e05694d3b21b95e4e1626d"
};

firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();
const firestore = firebase.firestore();
const database = firebase.database();

const { Timestamp, GeoPoint } = firebase.firestore;

export {
  firestore,
  database,
  storage,
  Timestamp, 
  GeoPoint
};


// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/firebase.js